import { z } from 'zod';
const FeatureSchema = z.object({
    icon: z.string().trim().min(1).max(40),
    title: z.string().trim().min(1).max(120),
    description: z.string().trim().min(1).max(600),
});
const AboutCredentialSchema = z.object({
    icon: z.string().trim().min(1).max(40),
    value: z.string().trim().min(1).max(60),
    label: z.string().trim().min(1).max(200),
});
const AboutServiceSchema = z.object({
    icon: z.string().trim().min(1).max(40),
    title: z.string().trim().min(1).max(120),
    description: z.string().trim().min(1).max(600),
});
const ContactOfficeSchema = z.object({
    country: z.string().trim().min(1).max(60),
    flag: z.string().trim().min(1).max(8),
    address: z.union([z.string().trim().max(240), z.null()]),
    phone: z.string().trim().min(1).max(40),
    phoneHref: z.string().trim().min(1).max(40),
    isHeadquarters: z.boolean().optional(),
});
const ContactSocialLinkSchema = z.object({
    platform: z.enum(['twitter', 'facebook', 'instagram', 'linkedin']),
    url: z.string().trim().url().max(500),
    label: z.string().trim().min(1).max(40),
});
const AboutPageSchema = z
    .object({
    eyebrow: z.string().trim().max(80).default(''),
    title: z.string().trim().min(1).max(200),
    subtitle: z.string().trim().max(600).default(''),
    storyTitle: z.string().trim().min(1).max(200),
    storyBody: z.string().trim().min(1).max(6000),
    credentials: z.array(AboutCredentialSchema).max(12),
    servicesEyebrow: z.string().trim().max(80).default(''),
    servicesTitle: z.string().trim().min(1).max(200),
    services: z.array(AboutServiceSchema).max(24),
    whyEyebrow: z.string().trim().max(80).default(''),
    whyTitle: z.string().trim().min(1).max(200),
    whyBody: z.string().trim().max(1200).default(''),
    whyPoints: z.array(z.string().trim().min(1).max(200)).max(12),
    clientsEyebrow: z.string().trim().max(80).default(''),
    clientsTitle: z.string().trim().min(1).max(200),
    clientsBody: z.string().trim().max(1200).default(''),
    ctaTitle: z.string().trim().min(1).max(200),
    ctaBody: z.string().trim().max(800).default(''),
})
    .optional();
const ContactPageSchema = z
    .object({
    eyebrow: z.string().trim().max(80).default(''),
    title: z.string().trim().min(1).max(200),
    subtitle: z.string().trim().max(600).default(''),
    email: z.string().trim().email('Invalid email').max(254),
    websiteUrl: z.string().trim().url().max(500),
    officesTitle: z.string().trim().min(1).max(200),
    officesSubtitle: z.string().trim().max(120).default(''),
    offices: z.array(ContactOfficeSchema).max(20),
    socialEyebrow: z.string().trim().max(80).default(''),
    socialHandle: z.string().trim().min(1).max(80),
    socialBody: z.string().trim().max(600).default(''),
    socialLinks: z.array(ContactSocialLinkSchema).max(8),
    ctaTitle: z.string().trim().min(1).max(200),
    ctaBody: z.string().trim().max(800).default(''),
})
    .optional();
const LandingContentSchema = z.object({
    hero: z.object({
        eyebrow: z.string().trim().max(80).default(''),
        title: z.string().trim().min(1).max(200),
        subtitle: z.string().trim().min(1).max(600),
        primaryCtaText: z.string().trim().min(1).max(40),
        primaryCtaHref: z.string().trim().min(1).max(500),
        secondaryCtaText: z.union([z.string().trim().max(40), z.null()]),
        secondaryCtaHref: z.union([z.string().trim().max(500), z.null()]),
    }),
    features: z.object({
        sectionEyebrow: z.string().trim().max(80).default(''),
        sectionTitle: z.string().trim().min(1).max(200),
        sectionSubtitle: z.string().trim().max(600).default(''),
        items: z.array(FeatureSchema).min(1).max(24),
    }),
    about: z.object({
        eyebrow: z.string().trim().max(80).default(''),
        title: z.string().trim().min(1).max(200),
        body: z.string().trim().min(1).max(4000),
    }),
    contact: z.object({
        eyebrow: z.string().trim().max(80).default(''),
        title: z.string().trim().min(1).max(200),
        body: z.string().trim().min(1).max(2000),
        email: z.string().trim().email('Invalid email').max(254),
        phone: z.union([z.string().trim().max(40), z.null()]),
        address: z.union([z.string().trim().max(300), z.null()]),
    }),
    footer: z.object({
        tagline: z.string().trim().min(1).max(200),
    }),
    aboutPage: AboutPageSchema,
    contactPage: ContactPageSchema,
});
export const PutLandingContentRequestSchema = z.object({
    content: LandingContentSchema,
});
//# sourceMappingURL=landing.schema.js.map